<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout row align-center>
        <v-flex xs12 sm6 d-flex>
          <template v-if="configuration.categoryPicker">
            <v-btn
                    v-show="!categoryPickerMode || state.filter"
                    color="primary"
                    dark
                    @click="categoryPickerMode = true"
                    style="max-width: 240px"
            >
              <span>
                <v-icon>chevron_left</v-icon>
              </span>
              {{state.category || 'All categories'}}
            </v-btn>
          </template>
          <v-select v-else
            ref="select"
            :items="categories"
            :label=" $t('Common.category')"
            v-model="state.category"
            @change="onChangeCategory"
            clearable
          ></v-select>
        </v-flex>

        <v-flex xs12 sm6 d-flex class="pl-3">
          <v-text-field
            v-model="state.filter"
            flat
            :label="$t('Action.search')"
            append-icon="search"
            hide-details
            clearable
            style="padding-bottom: 20px"
            @change="setFilter"
            @click:clear="setFilter('')"
          ></v-text-field>
        </v-flex>

        <v-flex>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="changeOrdered" :class="{'filter-icon-active': orderedOnly}">
                <v-icon>fas fa-history</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Common.orderedOnly')}}</span>
          </v-tooltip>
        </v-flex>
        <v-flex>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="changeFavorites" :class="{'filter-icon-active': favoritesOnly}">
                <v-icon>{{ !favoritesOnly ? 'far fa-star' : 'fas fa-star' }}</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Common.favoritesOnly')}}</span>
          </v-tooltip>
        </v-flex>
        <v-flex>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click.stop="changeSorting" :style="orderbyImageStyle()" :class="{'filter-icon-active': !state.ascending}">
                <v-icon>sort_by_alpha</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Common.sortBy')}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <v-list style="flex-direction: row; flex-wrap: wrap; display: flex" v-show="categoryPickerMode">
        <div
          v-for="(item, index) in categories"
          :key="index"
          @click="onChangeCategory(item)"
          style="cursor: pointer; display: flex; flex: 0;"
        >
          <v-list-tile-content style="padding: 20px;width: 200px;">
            <v-list-tile-title style="height: 160px">
              <v-img :src="categoryImage(item)" v-if="configuration.categoryImageBaseUrl"/>
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ item }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </div>
      </v-list>

      <v-data-iterator
        ref="data"
        v-show="!categoryPickerMode"
        content-tag="v-layout"
        row
        wrap
        :items="items"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="state.pagination"
        :total-items = "state.pagination.totalItems"
        @update:pagination="onUpdatePagination"
      >
        <v-flex
          style="padding: 10px"
          slot="item"
          slot-scope="props"
          xs12
          sm6
          md4
          lg3
        >
          <v-card :class="['item-card', getItemQuantity(props.item) ? 'active': '', props.item.ordered ? 'ordered' : '']" @click="handleClick(props.item)">

            <div class="item-star" @click="star(props.item)">
              <v-icon>{{props.item.favorite === null ? 'fas fa-circle-notch fa-spin' : !props.item.favorite ? 'far fa-star' : 'fas fa-star' }}</v-icon>
            </div>
            <div class="item-name">
                <span>{{ props.item.name }}</span>
            </div>

            <div class="item-img-cnt">
              <sec-img :key="props.item.ID" :src="getImageUrl(props.item)" alt=" " :title="props.item.name" class="item-img"/>
              <div v-if="props.item.description" class="item-description">
                <v-divider></v-divider>
                <div class="pa-3 caption" v-html="props.item.description"></div>
              </div>
            </div>

            <div class="price-and-cost" v-if="configuration.simplified !== true">
              <span class="price" v-if="props.item.fullprice">
                <span class="label">{{$t('Common.price')}}:</span>
                <span>{{props.item.fullprice.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
              </span>
              <span class="cost" v-if="props.item.nettotal">
                <span class="label">{{$t('Common.amount')}}:</span>
                <span>{{props.item.nettotal.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
              </span>
            </div>

            <div v-if="configuration.simplified !== true">
              <NumericInput
                v-model="$root.globalComponent.items[props.item.itemnum]"
                class="numeric-input"
                button-width="30%"
                :values="getQuantityScale(props.item)"
                :min="0"
                @input="onNumericInput(props.item, $event)">
              </NumericInput>
            </div>

          </v-card>
        </v-flex>
      </v-data-iterator>
    </v-container>
  </div>
</template>

<script>
  import NumericInput from '../components/NumericInput'
  import store from '../store'

  export default {
    name: 'Shop',
    components: {
      NumericInput
    },
    computed: {
      state() {
        return store.shop;
      },
      configuration() {
        return this.config || {}
      }
    },
    props: {
      config: {},
    },
    data() {
      return {
        categoryPickerMode: false,
        categories: [],
        rowsPerPageItems: [12, 24, 48, 96, { "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 }],
        items: [],
        favoritesOnly: false,
        orderedOnly: false,
      };
    },
    mounted() {
      this.getCategories();
      this.categoryPickerMode = this.configuration.categoryPicker;
    },
    methods: {
      getImageUrl(item) {
        return this.$root.route('item/' + item.ID + '/image')
      },
      onChangeCategory(cat) {
        this.categoryPickerMode = false;
        this.state.category = cat
        this.$refs.data.updatePagination( {page: 1} )
      },
      onUpdatePagination(paginationObject) {
        Object.keys(paginationObject).forEach(key => this.state.pagination[key] = paginationObject[key]);
        this.refresh()
      },
      getCategories() {
        this.$http.get(this.$root.route('items/tags')).then(
          response => {
            this.categories = response.data.result;
            console.log('categories', this.categories);
          },
          response => {
            console.error('Fail', response);
          });
      },
      getItemQuantity(item) {
        return this.$root.globalComponent.items[item.itemnum] || 0;
      },
      refresh() {
        const params = {
          favorites: this.favoritesOnly ? 'true' : undefined,
          ordered: this.orderedOnly ? 'true' : undefined,
          offset: (this.state.pagination.page || 1) - 1,
          limit: this.state.pagination.rowsPerPage,
          orderby: (this.state.ascending ? '-' : '') + 'name',
          tag: this.state.category
        };
        if (this.state.filter) {
          params['search'] = this.state.filter;
        }

        this.$http.get(this.$root.route('items'), {params}).then(
          response => {
            this.items = response.data.result.data;
            this.state.pagination.totalItems = response.data.result.count;
            // remove focus from select
            if (this.$refs.select) {
              this.$refs.select.blur();
            }
          },
          response => {
            console.error('Fail', response);
          });
      },
      setFilter(value) {
        this.categoryPickerMode = false;
        this.state.filter = value;
        this.refresh();
      },
      changeSorting() {
        this.state.ascending = !this.state.ascending;
        this.refresh();
      },
      orderbyImageStyle() {
        return this.state.ascending ? {float: 'left'} : {float: 'left', transform: 'rotate(180deg)'};
      },
      star(item) {
        const old = item.favorite;
        item.favorite = null;
        this.items = [
          ...this.items,
        ];

        const url = this.$root.route('item/' + item.ID + '/favorite');
        const result = old ? this.$http.delete(url) : this.$http.post(url, {})
        result.then(() => {
          this.refresh();
        })
      },
      changeFavorites() {
        this.favoritesOnly = !this.favoritesOnly;
        this.refresh();
      },
      changeOrdered() {
        this.orderedOnly = !this.orderedOnly;
        this.refresh();
      },
      onNumericInput(item, value) {
        console.log("oni", item, value);
        this.$http.post(this.$root.route('item/' + item.ID + '/' + value)).then(
          response => {
            console.log('Success item price', response);
            let res = response.body.result;
            item.fullprice = res.fullprice;
            item.nettotal = res.nettotal;
            item.taxamount = res.taxamount;
            //item.total = Math.round((item.nettotal + item.taxamount) * 1000000) / 1000000;
          },
          response => {
            console.log('Fail item price', response);
          });
      },
      getQuantityScale(item) {
        let scale = (item.quantityscale || '').split(',').map(x => x.trim());
        if (!this.$root.config.autoContinueQuantityScale)
          return scale;
        let reverse = scale.reverse();
        if (reverse[0] && reverse[1]) {
          let stepLo = parseInt(reverse[1], 10);
          let stepHi = parseInt(reverse[0], 10);
          let stepSize = stepHi - stepLo;
          for (let i=stepHi+stepSize; i<20000; i += stepSize)
            scale.push(i);
        }
        return scale;
      },
      handleClick(item) {
        if (this.configuration.simplified !== true) {
          return;
        }

        this.$root.globalComponent.addToCart({[item.itemnum]: 1});

        this.$root.globalComponent.items[item.itemnum] = 1;
        this.$root.globalComponent.currentView = 'Cart';

      },
      categoryImage(category) {
        const base = (category || 'unknown')
                .replace(/Ä/g, 'Ae')
                .replace(/Ü/g, 'Ue')
                .replace(/Ö/g, 'Oe')
                .replace(/ä/g, 'ae')
                .replace(/ü/g, 'ue')
                .replace(/ö/g, 'oe')
                .replace(/ß/g, 'ss')
                .replace(/\s/gi, '_')
                .replace(/[^A-Za-z0-9_\-]/gi, '-');
        return `${this.configuration.categoryImageBaseUrl}/${base}.png`;
      }
    }
  }
</script>

<style lang="scss">
  .v-menu__content {
    max-height: 300px !important;
  }
</style>

<style scoped>
    .v-menu__content {
      max-height: 60vh !important;
    }

    .item-star {
        cursor: pointer;
        position: absolute;
        top: 24px;
        left: 12px;
    }
  div.active.item-card {
    color: yellowgreen;
  }
    div.item-card {
        position: relative;
    }
  div.active.item-card span.cost,
  div.item-card span.price {
    width: 50%;
    display: inline-block;
    position: relative;
  }
  div.item-card span.cost {
    display: none;
  }
  div.item-card span.label {
    font-size: 12px; margin-right: 4px;
  }
  div.item-card .item-name {
    width: 100%;
    text-align: center;
    padding: 12px 12px 12px 48px;
    font-size: 16px;
  }
  div.item-card div.price-and-cost {
    text-align: center;
    margin-bottom: 10px;
    border-top: 1px solid rgba(255,255,255,0.12);
    padding-top: 10px;
  }
  div.numeric-input {
    height: 38px;
  }

  div.item-name {
    height: 72px;
    display: flex;
    align-items: center;
  }

  div.item-name SPAN {
    flex: 1 1 auto;
  }

  div.item-img-cnt {
    background: white;
    text-align: center;
    height: 200px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .item-img {
    max-height: 200px;
  }

  .item-description {
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.35);
    position: absolute;
    opacity: 0;
    transition: opacity .3s ease-in-out;
  }

  .item-card:hover .item-description {
      opacity: 1;
  }

  .item-card.ordered::after {
      content: ' ';
    pointer-events: none;
    z-index: 2;
    top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      box-shadow: 0 0 2px 1px #E29C53 inset;
      position: absolute;
  }

  .filter-icon-active {
    color: var(--v-primary-base)
  }

</style>
